var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZetLogo = function SvgZetLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#442F5A",
    d: "M62.186.121h-26.65l3.423 7.314h7.884V23.88h7.526V7.435h7.817zM21.894.121H.375v7.314h10.378L.374 16.565v7.314h21.519v-7.314H11.517l10.377-9.13zM41.478 16.565h-10.97v-1.26h10.36l-1.956-4.115-1.192-2.495h-7.212v-1.26h6.545L33.626.121H23.618V23.88h21.351z"
  })));
};
export default SvgZetLogo;